import { render, staticRenderFns } from "./testFlask.vue?vue&type=template&id=0665df31&scoped=true&"
import script from "./testFlask.vue?vue&type=script&lang=js&"
export * from "./testFlask.vue?vue&type=script&lang=js&"
import style0 from "./testFlask.vue?vue&type=style&index=0&id=0665df31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665df31",
  null
  
)

export default component.exports